


















import Vue from 'vue';
import SiteHeader from '@/components/modules/SiteHeader.vue';
import SiteFooter from '@/components/modules/SiteFooter.vue';
import SiteResponsiveMenu from '@/components/modules/SiteResponsiveMenu.vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';
import ServiceModal from '@/components/modules/App/Profile/Modals/ServiceModal.vue';
import PPDAndTPDConfirmModal from '@/components/modules/App/Profile/Modals/PPDAndTPDConfirmModal.vue';
import FlatDocumentsModal from '@/components/modules/App/Profile/Modals/FlatDocumentsModal.vue';
import ReminderModal from '@/components/modules/App/Profile/Modals/ReminderModal.vue';
import ApproveModal from '@/components/modules/App/Profile/Modals/ApproveModal.vue';
import ApartmentAcceptanceModal from '@/components/modules/App/Profile/Modals/ApartmentAcceptanceModal.vue';
import SubmitDocumentsModal from '@/components/modules/App/Profile/Modals/SubmitDocumentsModal.vue';
import { ThisTypedComponentOptionsWithRecordProps } from 'vue/types/options';
import MainActionModal from '@/components/modules/App/Profile/Modals/MainActionModal.vue';

interface Data {
  isMenuOpened: boolean;
}

interface Methods {
  switchOpenMenu: () => void;
  closeMenu: () => void;
  getPPDAndTPDLinks: () => void;
  getOrganization: () => void;
  setCurrentReminderLink: (link: string | null) => void;
  setReminderModalOpen: (open: boolean) => void;
  setServiceModalOpen: (open: boolean) => void;
  setPPDAndTPDConfirmModalOpen: (open: boolean) => void;
  setFlatDocumentsModalOpen: (open: boolean) => void;
  setApprovalModalOpen: (open: boolean) => void;
  setApartmentAcceptanceModalOpened: (open: boolean) => void;
  setSubmitDocumentsModalOpen: (open: boolean) => void;
  setCurrentLeadForDocuments: (lead: unknown) => void;
}

interface Computed {
  serviceModalOpen: boolean;
  PPDAndTPDConfirmModalOpen: boolean;
  flatDocumentsModalOpen: boolean;
  reminderModalOpen: boolean;
  approvalModalOpen: boolean;
  isApartmentAcceptanceModalOpened: boolean;
  submitDocumentsModalOpen: boolean;
}

interface Props {}

export default Vue.extend({
  name: 'AppTemplate',
  components: {
    SiteHeader,
    SiteFooter,
    SiteResponsiveMenu,
    ServiceModal,
    PPDAndTPDConfirmModal,
    FlatDocumentsModal,
    ReminderModal,
    ApproveModal,
    ApartmentAcceptanceModal,
    MainActionModal,
    SubmitDocumentsModal
  },
  data() {
    return {
      isMenuOpened: false,
    };
  },
  computed: {
    ...mapGetters([
      'serviceModalOpen',
      'PPDAndTPDConfirmModalOpen',
      'flatDocumentsModalOpen',
      'reminderModalOpen',
      'approvalModalOpen',
      'isApartmentAcceptanceModalOpened',
      'isMainActionModalOpened',
      'submitDocumentsModalOpen'
    ]),
  },
  mounted() {
    this.getPPDAndTPDLinks();
    this.getOrganization();
  },
  methods: {
    ...mapMutations([
      'setServiceModalOpen',
      'setPPDAndTPDConfirmModalOpen',
      'setFlatDocumentsModalOpen',
      'setReminderModalOpen',
      'setApprovalModalOpen',
      'setCurrentReminderLink',
      'setApartmentAcceptanceModalOpened',
      'setMainActionModalOpened',
      'setSubmitDocumentsModalOpen',
      'setCurrentLeadForDocuments'
    ]),
    ...mapActions(['getPPDAndTPDLinks', 'getOrganization']),
    switchOpenMenu() {
      this.isMenuOpened = !this.isMenuOpened;
    },
    closeMenu() {
      this.isMenuOpened = false;
    },
  },
} as ThisTypedComponentOptionsWithRecordProps<Vue, Data, Methods, Computed, Props>);
